import { Component, OnInit } from '@angular/core';

import { AuthService } from '../auth.service'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  menuOpen: boolean;
  

  constructor(public auth: AuthService) { }

  ngOnInit() {
    this.menuOpen = false;
  }

  toggleMenu(): void {
    this.menuOpen =!this.menuOpen;
  }

}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts